import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AttendeeSlots from '../components/attendee/AttendeeSlots';
import Overlay from '../components/common/Overlay';
import { useAppSelector } from '../hooks/store';
import { Request } from '../types';
import getFileURL from '../utils/getFileURL';
import AttendeeRequestStatus from '../components/attendee/AttendeeRequestStatus';
import './Attendee.css';
import Categories from '../components/common/Categories';
import Info from '../components/common/Info';
//
// Страница участника
//
const Attendee = () => {
	const { t, i18n } = useTranslation();
	const name1 = i18n.language === 'en' ? 'name_en' : 'name_ru';
    const name2 = i18n.language === 'en' ? 'name_ru' : 'name_en';
    const attendee = useAppSelector(store => store.attendee);
    const requests = useAppSelector(store => store.requests);
    const [ request, setRequest ] = useState<Request|undefined>(undefined);
    // Узнаем есть ли у нас запрос с этим участником.
    // Запрос может быть только один в любом статусе.
    useEffect(() => {
        const req = requests.find(r => r.from_id === attendee?.id || r.to_id === attendee?.id);
        if(req) setRequest(req); else setRequest(undefined);
    }, [ attendee, requests ]);

    if(!attendee) return <Overlay>{t('common.loading')}</Overlay>;

	return (
        <Overlay>
            <div className='Attendee'>
                <div className='Name'>
                    <img alt='Avatar' className='Avatar' src={getFileURL(attendee.avatar)}/>
                    <div className='Text'>
                        <div className='Name1'>{attendee[name1]}</div>
                        <div className='Name2'>{attendee[name2]}</div>
                    </div>
                </div>
                <Info attendee={attendee}/>
                <AttendeeRequestStatus request={request} attendee_id={attendee.id}/>
                <AttendeeSlots request={request} attendee_id={attendee.id} />
                <Categories attendee={attendee}/>
            </div>
        </Overlay>
	);
};

export default Attendee;
